import Plyr from 'plyr';

export default class InlineAudioPlayer {
	constructor(el) {
		// DOM Elements
		this.el = el;
		this.playerEl = this.el.querySelector('.c-inline-audio-player');
		this.toggleButton = this.el.querySelector('.c-play-button');
		this.isPlaying = false;

		// Events
		this.events = [];

		this.DASHARRAY = 166;
	}

	init() {
		this.setProgress(0);

		this.player = new Plyr(this.playerEl, {
			loadSprite: false,
			volume: 1,
		});

		this.player.on('play', () => {
			this.isPlaying = true;
			this.el.classList.add('is-playing');

			this.dispatch('play');
			document.dispatchEvent(new CustomEvent('inlineaudioplaying', { detail: this.el }));
		});

		this.player.on('pause', () => {
			this.isPlaying = false;
			this.el.classList.remove('is-playing');
			this.dispatch('pause');
		});

		this.player.on('ended', () => {
			this.isPlaying = false;
			this.setProgress(0);
		});

		this.player.on('timeupdate', e => {
			const progress = e.detail.plyr.currentTime / e.detail.plyr.duration;
			this.setProgress(progress);
		});

		this.toggleButton.addEventListener('click', e => {
			this.isPlaying ? this.pause() : this.play();
		});
	}

	pause() {
		this.player.pause();
	}

	play() {
		this.player.play();
	}

	setProgress(value) {
		const progress = value * this.DASHARRAY + this.DASHARRAY;
		this.el.style.setProperty('--play-button-progress', progress);
	}

	on(eventName, callback) {
		this.events.push({
			eventName,
			callback,
		});
	}

	dispatch(eventName) {
		const eventObjects = this.events.filter(event => event.eventName === eventName);

		if (!eventObjects) {
			return;
		}

		eventObjects.forEach(eventObject => {
			eventObject.callback(this);
		});
	}

	destroy() {
		this.player.destroy();
	}
}
